<div *ngIf="items && items.length > 0" class="columns is-multiline">
    <div *ngIf="(getItems(['deliverySelectable', 'deliveryOverlay'])?.length ?? 0) > 0" class="column is-12">
        <div class="border-bottom">
            <p class="subtitle mb-0">Versand</p>
            <div class="control">
                <iw-shop-dynamic-article-items [writeable]="writeable" [items]="getItems(['deliverySelectable', 'deliveryOverlay'])"></iw-shop-dynamic-article-items>
            </div>
        </div>
    </div>
    <div *ngIf="(getItems(['additionalArticle'])?.length ?? 0) > 0" class="column is-12">
        <div class="border-bottom pb-2">
            <p class="subtitle mb-0">Zugabeartikel</p>
            <div class="control">
                <iw-shop-dynamic-article-items [writeable]="writeable" [items]="getItems(['additionalArticle'])" ></iw-shop-dynamic-article-items>
            </div>
        </div>
    </div>
    <div *ngIf="(getItems(['selection', 'selectionWithOptionalMappingToCustomer'])?.length ?? 0) > 0" class="column is-12">
        <div class="border-bottom pb-2">
            <p class="subtitle mb-0">Optionen</p>
            <div class="control">
                <iw-shop-dynamic-article-items [writeable]="writeable" [items]="getItems(['selection', 'selectionWithOptionalMappingToCustomer'])" ></iw-shop-dynamic-article-items>
            </div>
        </div>
    </div>
</div>
